export default __webpack_public_path__ + "static/media/outsourcing.3f700e4f.mp4";